module.exports = "pegasus_template/assets/blocks/tile-layout-10.png";